export default __webpack_public_path__ + "static/travelrapid_step1_healgen-8eae22e26905f3f3ca19e7dd9c35a6fc.svg";